import React from 'react'
import './Ranking.css'
//assets
import iconKing from '../../assets/iconKing.png'
import profileDefault from '../../assets/profileDefault.png'

const Ranking = ({ data = [], title = 'Top customers', height = "auto", width = 200 }) => {
  // Validar que data sea un array y no esté vacío
  const isValidData = Array.isArray(data) && data.length > 0;

  const urlProfile = (avatar) => {
    if (avatar) {
      return `${process.env.REACT_APP_PROFILE_URL}${avatar}`;
    }
    return profileDefault;
  };

  return (
    <div className="ranking-container" style={{ height: height, width: width }}>
      <h2 className="ranking-title">{title}</h2>
      
      {isValidData ? (
        <div className="ranking-list">
          {data.map((item, index) => (
            <div key={index} className="ranking-item">
              <div className="ranking-position" style={{ backgroundColor: index === 0 ? '#00C39A' : '#0E5F79' }}>
                {index + 1}
              </div>
              
              <div className="ranking-user-avatar">
                <img src={urlProfile(item.profile_photo)} alt={`${item.name} avatar`} />
              </div>
              
              <div className="ranking-user-info">
                <h3 className="ranking-user-name">{item.name || item.group_name || 'User name'}</h3>
                <p className="ranking-user-service">
                  Most popular service: {item.most_popular_service || item.top_service || ''}
                </p>
              </div>
              
              <div className="ranking-score">
                <span className="ranking-score-value">{item.total_services || item.barter_bucks || 0}</span>
                <span className="ranking-score-label">{item.total_services ? 'Services' : 'Barter Bucks'}</span>
                {index === 0 && <img src={iconKing} alt="King icon" className="king-icon" />}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="ranking-no-data">No hay datos disponibles</div>
      )}
    </div>
  )
}

export default Ranking